<template>
  <form>
    <CaretButton tag="label">
      {{ str('efriends.sort') }} ({{ str(`efriends.sorting.${order}`) }})
      <select class="sort__input" v-model="order">
        <option
          v-for="item in orderValues"
          :value="item.value"
          :key="item.value"
        >
          {{ item.label }}
        </option>
      </select>
    </CaretButton>
  </form>
</template>

<script>
  import { defineComponent, computed } from '@vue/composition-api'
  import { OrderTypes } from '@/components/efriends/sortFactory'
  import CaretButton from '@/components/efriends/CaretButton'

  export default defineComponent({
    components: { CaretButton },
    setup(props, { root }) {
      const store = root.$store
      const order = computed({
        get: () => store.state.settings.cubeOrder,
        set: (orderType) => store.commit('setCubeOrder', orderType),
      })

      const orderValues = Object.keys(OrderTypes).map((key) => {
        return {
          label: store.state.strings.efriends.sorting[key],
          value: key,
        }
      })

      return { order, orderValues }
    },
  })
</script>

<style lang="scss" scoped>
  .sort__input {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    cursor: pointer;
  }
</style>
